module.exports = __webpack_public_path__ + "img/asc.568ae40b.svg";